import { isMock } from '../config'
import { pagosMock } from './mock'
import { pagosReal } from './real'
import type { PagosService } from './types'

export const pagosService: PagosService = isMock('pagos') ? pagosMock : pagosReal
export type { CardInput, InStayConsent, InStayConsentInput, Charge, ClientType, FiscalData, InvoiceInfo, PagosService, PagosStay, PaymentKind, PaymentLine, PaymentMethodKind, PaymentOutcome, PaymentRequest, PaymentStart, PaymentSummary, Receipt, SavedCard, SavedCardInfo, TouristTax } from './types'
export { IN_STAY_CONSENT_TEXT_VERSION } from './types'
export { PAYMENT_WAIT_MS, readPendingPayment, writePendingPayment } from './flow'
export type { PendingPayment } from './flow'
